
import React from 'react';

// Production optimization component
export const ProductionOptimizer: React.FC = () => {
  // Comprehensive console cleanup in production
  if (process.env.NODE_ENV === 'production') {
    const noop = () => {};
    console.log = noop;
    console.warn = noop;
    console.info = noop;
    console.debug = noop;
    console.table = noop;
    console.group = noop;
    console.groupEnd = noop;
  }

  return null;
};

// Performance monitoring
export const PerformanceMonitor = {
  // Monitor component render times
  measureRender: (componentName: string, renderFunction: () => void) => {
    if (process.env.NODE_ENV === 'development') {
      const start = performance.now();
      renderFunction();
      const end = performance.now();
      console.log(`${componentName} render time: ${end - start}ms`);
    } else {
      renderFunction();
    }
  },

  // Monitor API call performance
  measureApiCall: async (apiName: string, apiCall: () => Promise<any>) => {
    const start = performance.now();
    try {
      const result = await apiCall();
      const end = performance.now();
      
      if (process.env.NODE_ENV === 'development') {
        console.log(`${apiName} API call time: ${end - start}ms`);
      }
      
      return result;
    } catch (error) {
      const end = performance.now();
      
      if (process.env.NODE_ENV === 'development') {
        console.error(`${apiName} API call failed after ${end - start}ms:`, error);
      }
      
      throw error;
    }
  }
};
